import { render, staticRenderFns } from "./SurveySettings.vue?vue&type=template&id=6c4104f0&"
import script from "./SurveySettings.vue?vue&type=script&lang=ts&"
export * from "./SurveySettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports